import http from "../api";

export const getDashboardNumbers = async (data) => {
  let url = `/dashboard/dashboard-numbers`;
  Object.keys(data).forEach((filter, index) => {
    url =
      url +
      `${index === 0 ? "?" : "&"}${filter}FromDate=${
        data[filter]?.fromDate
      }&${filter}ToDate=${data[filter]?.toDate}`;
  });
  return await http.get(url);
};

export const getBusesDataWrtEnergy = async (data) => {
  const { fromDate, toDate, technology } = data;
  return await http.get(
    `/dashboard/bus-energy?fromDate=${fromDate}&toDate=${toDate}&technology=${technology}`
  );
};

export const getChargersDataWrtPower = async (data) => {
  const { fromDate, toDate, technology } = data;
  return await http.get(
    `/dashboard/charger-power?fromDate=${fromDate}&toDate=${toDate}&technology=${technology}`
  );
};
